import React, { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import api from "@/lib/api";

export default function AuthImage({ fileId, localUrl, thumb = false, className, alt = "", ...rest }) {
  const [url, setUrl] = useState(localUrl || null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (localUrl) { setUrl(localUrl); return; }
    let active = true;
    let objectUrl = null;
    api.get(`/files/${fileId}/download${thumb ? "?thumb=1" : ""}`, { responseType: "blob" })
      .then((r) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(r.data);
        setUrl(objectUrl);
      })
      .catch(() => active && setErr(true));
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [fileId, localUrl, thumb]);

  if (err)
    return <div className={`flex items-center justify-center bg-slate-100 ${className}`}><ImageOff className="h-5 w-5 text-slate-400" /></div>;
  if (!url) return <div className={`bg-slate-100 animate-pulse ${className}`} />;
  return <img src={url} alt={alt} className={className} {...rest} />;
}
